import { Injectable } from '@angular/core';
import { ITableColumn } from '../../common/models/table';
import { DataFormatter } from './data-formatter.service';
import { ColumnDefinitionFormatType } from '../enums/column-definition-format-type';

@Injectable()
export class ColumnFormatterService {
  constructor(private readonly dataFormatter: DataFormatter) { }

  formatByType(data: any, formatType: ColumnDefinitionFormatType) {
    return this.dataFormatter.formatByType(data, formatType);
  }

  formatByColumnType(rowData, columnDefinition: ITableColumn): string {
    return this.dataFormatter.formatByType(rowData, columnDefinition.type);
  }
}
